import { defineMessages } from 'react-intl';

export default defineMessages({
  privacy_policy_label: {
    id: 'app.pages.eligibility.user.data.legislation.label',
    defaultMessage:
      'By advancing on the website, you accept the user data used to send to affiliates. For more information,',
  },
  privacy_policy_link: {
    id: 'app.pages.eligibility.user.data.legislation.link',
    defaultMessage: 'see the user data legislation',
  },
});
